import { isNullOrWhiteSpace } from "./reportHelpers";

export const resolveProxyImageUrl = (str, imageProxyBaseUrl) => {
  if (isNullOrWhiteSpace(str)) return null;
  const trimmed = str.trim();
  if (trimmed.startsWith("data:")) return trimmed;
  if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) {
    return `${imageProxyBaseUrl}${trimmed}`;
  }
  if (trimmed.length > 500 && /^[A-Za-z0-9+/=]+$/.test(trimmed)) {
    return `data:image/jpeg;base64,${trimmed}`;
  }
  return `${imageProxyBaseUrl}${trimmed}`;
};
